import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const ConfirmationContainer = styled.div`
  align-items: center;
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;
  padding: 20px;
  width: 768px;
`

export const ConfirmationModalHeader = styled.div`
  ${typography.up2.semiBoldSans};
`
export const ConfirmationModalButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  padding: 10px;
`
export const FlexRowColumn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`
